<form #f="ngForm" [formGroup]="phoneForm">
  <dhs-ngx-intl-tel-input
    [cssClass]="'custom form-control'"
    [preferredCountries]="this.preferredCountries"
    [enablePlaceholder]="question.enablePlaceholder"
    [searchCountryFlag]="question.searchCountryFlag"
          [searchCountryField]="[
            SearchCountryField.Iso2,
            SearchCountryField.Name
          ]"
    [selectedCountryISO]="this.selectedCountryISO"
    [maxLength]="question.maxlength"
    [phoneValidation]="true"
    [separateDialCode]="question.separateDialCode"
    (change)="changeValue($event)" [(ngModel)]="phone"
    name="phone"
    formControlName="phone"
    >
  </dhs-ngx-intl-tel-input>
</form>
@if (clicked) {
  <div>
    @if (f.form.value.phone && f.form.controls['phone'].errors) {
      <div  [ngClass]="clicked?'invalid-intl-tel':''">Invalid Phone Number</div>
    }
  </div>
}